import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Qué pasa si un día no puedo hacer el ejercicio?',
  answer: 'No hay problema. Podés retomarlo al día siguiente. La idea es que se adapte a tu ritmo, sin culpa. Incluso podés repetir el audio otro día.'
}, {
  question: '¿Necesito experiencia previa en journaling o meditación?',
  answer: 'No, este kit está pensado para cualquier persona, sin importar el nivel de experiencia. Las instrucciones son simples y guiadas paso a paso.'
}, {
  question: '¿Puedo usar el kit más de una vez?',
  answer: 'Sí, podés repetir el ciclo de 7 días tantas veces como quieras. Muchos usuarios lo usan cada mes para mantener su equilibrio emocional.'
}, {
  question: '¿Cuánto tiempo tengo acceso al material?',
  answer: 'El acceso es de por vida. Una vez descargado, podés usar el PDF y los audios cuando quieras.'
}, {
  question: '¿Qué hago si no me siento mejor después de unos días?',
  answer: 'Es normal. A veces lleva un poco más de tiempo. Podés ajustar el momento del día en que lo hacés, o volver a escuchar los audios. Lo importante es la constancia.'
}];
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={index * 0.1} data-id="element-14">
      <div className="border-b border-[#3D3229]/10 last:border-b-0" data-id="element-15">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between py-6 text-left gap-4 group focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C4703F] focus-visible:ring-offset-2 rounded-lg" aria-expanded={isOpen} data-id="element-16">
          <span className="text-lg font-semibold text-[#3D3229] group-hover:text-[#C4703F] transition-colors duration-200" data-id="element-17">
            {question}
          </span>
          <motion.div animate={{
          rotate: isOpen ? 180 : 0
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="flex-shrink-0" data-id="element-18">
            <ChevronDown className="w-5 h-5 text-[#C4703F]" data-id="element-19" />
          </motion.div>
        </button>
        <AnimatePresence initial={false} data-id="element-20">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.35,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="overflow-hidden" data-id="element-21">
              <p className="pb-6 text-[#3D3229]/75 leading-relaxed pr-12" data-id="element-22">
                {answer}
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </FadeIn>;
}
export function FAQSection() {
  return <section className="py-24 px-4 bg-[#FDF8F3]" data-id="element-23">
      <div className="container max-w-3xl mx-auto" data-id="element-24">
        <FadeIn data-id="element-25">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#3D3229] mb-4" data-id="element-26">
            Preguntas frecuentes
          </h2>
          <p className="text-center text-[#3D3229]/60 mb-14 text-lg" data-id="element-27">
            Todo lo que necesitás saber antes de empezar
          </p>
        </FadeIn>

        <div className="bg-white rounded-2xl shadow-sm border border-[#3D3229]/5 px-8 md:px-10" data-id="element-28">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} index={index} data-id="element-29" />)}
        </div>
      </div>
    </section>;
}